import { render } from "./main.vue?vue&type=template&id=0db5c200"
import script from "./main.vue?vue&type=script&lang=ts"
export * from "./main.vue?vue&type=script&lang=ts"

import "./main.vue?vue&type=style&index=0&id=0db5c200&lang=css"
script.render = render

export default script